fragment CalcuraFieldListItemFragment on CalcuraFieldListItem {

    id
    label
    value
    position

    default_option
    order_details
    tooltip_position
    tooltip_message

    media {
        ...MediaFragment
    }

}